var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { "label-width": "0" } },
        [
          _c("el-divider", { staticClass: "custom-divider" }, [
            _vm._v(_vm._s(_vm.i18nt("designer.setting.customLabelIcon"))),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: _vm.i18nt("designer.setting.labelIconClass") } },
        [
          _c("el-input", {
            attrs: { type: "text" },
            model: {
              value: _vm.optionModel.labelIconClass,
              callback: function ($$v) {
                _vm.$set(_vm.optionModel, "labelIconClass", $$v)
              },
              expression: "optionModel.labelIconClass",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }